export class MarinaMessageVariables {
  id?: number;
  messageType: string;
  varName: string;
  fieldName: string;
  description?: string;
  exampleValue?: string;
}

